import { Divider, LayoutBand, useContainerWidth } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import PersonBannerSkeleton from './components/person-banner/PersonBannerSkeleton'
import SourceCentricBannerSkeleton from './components/person-banner/SourceCentricBannerSkeleton'
import PersonPageTabsSkeleton from './components/PersonPageTabsSkeleton'
import PersonPageContentSkeleton from './PersonPageContentSkeleton'
import useSourceCentricDetailsFlag from '../data-service/useSourceCentricDetailsFlag'
import { CLASSIC_GUTTERS, SOURCE_CENTRIC_GUTTERS } from './constants'

type Props = {
  children?: ReactNode
}

export default function PersonPageSkeleton({ children }: Props = {}): JSX.Element {
  const atContainerWidth = useContainerWidth()
  const isMobile = atContainerWidth({ lg: false, default: true })
  const { data: sourceCentricDetailsFlag } = useSourceCentricDetailsFlag()
  const isSourceCentric = !!sourceCentricDetailsFlag?.isOn

  if (children) {
    return <>{children}</>
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      {isSourceCentric ? <SourceCentricBannerSkeleton /> : <PersonBannerSkeleton isMobile={isMobile} />}
      <Divider />
      <PersonPageTabsSkeleton />
      <LayoutBand
        maxWidth="lg"
        marginY={isSourceCentric ? SOURCE_CENTRIC_GUTTERS : CLASSIC_GUTTERS}
        marginX={isSourceCentric ? SOURCE_CENTRIC_GUTTERS : CLASSIC_GUTTERS}
      >
        <PersonPageContentSkeleton />
      </LayoutBand>
    </div>
  )
}
